// listStyles.js - 列表样式注入工具函数
export const injectListStyles = () => {
  if (!document.getElementById('notification-list-styles')) {
    const style = document.createElement('style');
    style.id = 'notification-list-styles';
    style.innerHTML = `
      .notification-content-display ol,
      .notification-content-display ul {
        padding-left: 1.5em;
        margin: 0.5em 0;
      }
      .notification-content-display ol { list-style-type: decimal; }
      .notification-content-display ul { list-style-type: disc; }
      .notification-content-display li {
        display: list-item;
        line-height: 1.8;
        margin: 0.25em 0;
      }
      .notification-content-display ol ol { list-style-type: lower-alpha; }
      .notification-content-display ol ol ol { list-style-type: lower-roman; }
      .notification-content-display ul ul { list-style-type: circle; }
      .notification-content-display ul ul ul { list-style-type: square; }
      .notification-content-display li > ol,
      .notification-content-display li > ul {
        margin-top: 0.25em;
        margin-bottom: 0.25em;
      }
      .notification-content-display p { margin: 0.5em 0; }
      .notification-content-display strong { font-weight: bold; }
      .notification-content-display em { font-style: italic; }
      .notification-content-display u { text-decoration: underline; }
      .notification-content-display s { text-decoration: line-through; }

      /* 图片基础样式 */
      .notification-content-display img {
        max-width: 100%;
        height: auto;
        display: block;
        margin-top: 1em;
        margin-bottom: 1em;
      }

      /* 文本对齐 */
      .notification-content-display .ql-align-center { text-align: center; }
      .notification-content-display .ql-align-right  { text-align: right; }
      .notification-content-display .ql-align-left   { text-align: left; }

      /* 图片对齐：block 元素不受 text-align 影响，必须用 margin */
      .notification-content-display .ql-align-center img {
        margin-left: auto;
        margin-right: auto;
      }
      .notification-content-display .ql-align-right img {
        margin-left: auto;
        margin-right: 0;
      }
      .notification-content-display .ql-align-left img {
        margin-left: 0;
        margin-right: auto;
      }

      .notification-content-display a { color: #1890ff; text-decoration: none; }
      .notification-content-display a:hover { text-decoration: underline; }
    `;
    document.head.appendChild(style);
  }
};